import type { ID } from '@/types/basic'
import * as R from 'remeda'

export const isActive = <IsSingle extends boolean>(
  item: ID | ID[],
  isSingle: IsSingle,
  value?: IsSingle extends true ? ID | ID[] | null : ID[] | ID[][] | null,
) => {
  if (!value) return false

  if (isSingle) {
    return Array.isArray(value) && Array.isArray(item) ? R.isDeepEqual(item, value) : value === item
  }
  if (!Array.isArray(value)) return false
  return value.some(v => (Array.isArray(item) ? R.isDeepEqual(v, item) : v === item))
}
